import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-htc-ltc-sanction-form',
  templateUrl: './htc-ltc-sanction-form.component.html',
  styleUrls: ['./htc-ltc-sanction-form.component.css']
})
export class HtcLtcSanctionFormComponent implements OnInit {
  title="HTC/LTC Sanction";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/employee-claims/htc-ltc-sanction/htc-ltc-sanction-form/htc-ltc-sanction-form.component.ts